/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.Faq__Item');

    faqItems.forEach(item => {
      const questionBtn = item.querySelector('.Faq__Question');
      const answerWrapper = item.querySelector('.Faq__AnswerWrapper');

      // Set initial styles for animation
      answerWrapper.style.overflow = 'hidden';
      answerWrapper.style.transition = 'height 0.3s ease';

      questionBtn.addEventListener('click', () => {
        const isOpen = item.getAttribute('aria-expanded') === 'true';

        // Close all items
        faqItems.forEach(i => {
          i.setAttribute('aria-expanded', 'false');
          const wrapper = i.querySelector('.Faq__AnswerWrapper');
          wrapper.setAttribute('aria-hidden', 'true');
          wrapper.style.height = '0px';
        });

        // Open clicked item if it was closed
        if (!isOpen) {
          item.setAttribute('aria-expanded', 'true');
          answerWrapper.setAttribute('aria-hidden', 'false');

          // Temporarily set height to auto to get full height
          answerWrapper.style.height = 'auto';
          const fullHeight = answerWrapper.scrollHeight + 'px';
          answerWrapper.style.height = '0px';

          // Trigger reflow and then animate to full height
          requestAnimationFrame(() => {
            answerWrapper.style.height = fullHeight;
          });
        }
      });
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
  function getProductData(product) {
    var productJsonEl = product.querySelector('[data-product-json]');
    if (!productJsonEl) return null;

    try {
      return JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function getColorOptionIndex(productData) {
    if (!productData || !productData.product || !productData.product.options) return -1;

    var colorOptionNames = ['color', 'colour', 'couleur', 'colore', 'farbe', 'farve', 'färg', '색', '色'];
    var options = productData.product.options;

    for (var i = 0; i < options.length; i++) {
      if (colorOptionNames.indexOf(String(options[i]).toLowerCase()) !== -1) {
        return i;
      }
    }

    return -1;
  }

  function findVariantByImageId(productData, imageId) {
    if (!productData || !productData.product || !productData.product.variants) return null;

    var variants = productData.product.variants;

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];

      if (variant.featured_image && String(variant.featured_image.id) === String(imageId)) {
        return variant;
      }

      if (variant.image_id && String(variant.image_id) === String(imageId)) {
        return variant;
      }
    }

    return null;
  }

  function selectColorValue(product, colorOptionIndex, colorValue) {
    var optionPosition = colorOptionIndex + 1;

    var buttons = product.querySelectorAll(
      '.Popover__Value_nah[data-action="select-value"][data-option-position="' + optionPosition + '"]'
    );

    var matchedButton = Array.prototype.find.call(buttons, function (button) {
      return button.getAttribute('data-value') === colorValue;
    });

    if (!matchedButton) return;

    if (!matchedButton.classList.contains('is-selected')) {
      matchedButton.click();
    }
  }

  function syncVariantFromSlide(product, slideEl) {
    if (!product || !slideEl) return;

    var imageId = slideEl.getAttribute('data-image-id');
    if (!imageId) return;

    var productData = getProductData(product);
    if (!productData) return;

    var colorOptionIndex = getColorOptionIndex(productData);
    if (colorOptionIndex === -1) return;

    var matchedVariant = findVariantByImageId(productData, imageId);
    if (!matchedVariant || !matchedVariant.options || !matchedVariant.options[colorOptionIndex]) return;

    var colorValue = matchedVariant.options[colorOptionIndex];
    selectColorValue(product, colorOptionIndex, colorValue);
  }

  function syncSelectedNav(product, slideEl) {
    if (!product || !slideEl) return;

    var slideId = slideEl.getAttribute('id');
    if (!slideId) return;

    product.querySelectorAll('.Product__SlideshowNavImage, .Product__SlideshowNavDot').forEach(function (el) {
      el.classList.remove('is-selected');
    });

    var activeNav = product.querySelector(
      '.Product__SlideshowNavImage[href="#' + slideId + '"], .Product__SlideshowNavDot[href="#' + slideId + '"]'
    );

    if (activeNav) {
      activeNav.classList.add('is-selected');
    }
  }

  function initProductSlideshowSync(product) {
    var slideshowEl = product.querySelector('.Product__Slideshow');
    if (!slideshowEl || typeof Flickity === 'undefined') return;

    var flkty = Flickity.data(slideshowEl);
    if (!flkty) return;

    if (slideshowEl.dataset.variantSyncInit === 'true') return;
    slideshowEl.dataset.variantSyncInit = 'true';

    flkty.on('select', function () {
      var selectedCell = flkty.selectedElement;
      if (!selectedCell) return;

      syncSelectedNav(product, selectedCell);
      syncVariantFromSlide(product, selectedCell);
    });
  }

  function waitForFlickityAndInit() {
    var products = document.querySelectorAll('.Product');

    products.forEach(function (product) {
      initProductSlideshowSync(product);
    });
  }

  // init po loadu
  waitForFlickityAndInit();

  // malý retry, protože theme někdy Flickity initne až o chlup později
  setTimeout(waitForFlickityAndInit, 500);
  setTimeout(waitForFlickityAndInit, 1200);

  // klik na thumbnail / dot
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.Product__SlideshowNavImage, .Product__SlideshowNavDot');
    if (!trigger) return;

    var product = trigger.closest('.Product');
    if (!product) return;

    var slideshowEl = product.querySelector('.Product__Slideshow');
    if (!slideshowEl || typeof Flickity === 'undefined') return;

    var flkty = Flickity.data(slideshowEl);
    if (!flkty) return;

    var targetId = trigger.getAttribute('href');
    if (!targetId || targetId.charAt(0) !== '#') return;

    var targetSlide = product.querySelector(targetId);
    if (!targetSlide) return;

    event.preventDefault();

    var targetIndex = parseInt(targetSlide.getAttribute('data-image-position'), 10);
    if (isNaN(targetIndex)) return;

    flkty.select(targetIndex);

    syncSelectedNav(product, targetSlide);
    syncVariantFromSlide(product, targetSlide);
  });
});
